// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container___aRIt","image":"Hero_image__ETdpy","text":"Hero_text__EkWhn"};